module.exports = __webpack_public_path__ + "static/media/optimize.1de08d7a.svg";